/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreatePayoutRequestPurpose = typeof CreatePayoutRequestPurpose[keyof typeof CreatePayoutRequestPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutRequestPurpose = {
  'self-use': 'self-use',
  'buy-goods': 'buy-goods',
  spending: 'spending',
  household: 'household',
  payroll: 'payroll',
  'personal-savings': 'personal-savings',
  'family-living-expenses': 'family-living-expenses',
  'company-expense': 'company-expense',
} as const;
